// ===== Module features for easy import in ClientContainer=====

import ForecastAnalyticsContainer from './Analytics';
import ForecastForecastContainer from './Forecast';

import IngredientsConsumption from './Analytics/IngredientsConsumption';
import PastMix from './Analytics/PastMix';
import Sales from './Analytics/Sales';

import DashboardForecastsContainer from './Forecast/Forecasts/containers/DashboardForecastsContainer';
// TODO INP-1644
import PoSProductionPlanning from './Forecast/PoSProductionPlanning';
import ProductMix from './Forecast/ProductMix';
import SalesPlanning from './Forecast/SalesPlanning';

const ForecastModule = {
  ForecastAnalyticsContainer,
  ForecastForecastContainer,
  PastMix,
  Sales,
  IngredientsConsumption,
  DashboardForecastsContainer,
  ProductMix,
  PoSProductionPlanning,
  SalesPlanning,
};

export default ForecastModule;
